module.exports = __webpack_public_path__ + "static/media/middle.015df607.png";